import { StyledVerticalContainer } from '../Container';
import { Dropdown, IDropdownProps } from '../Dropdown';
import { StyledText } from './DropdownBlock.styled';

export interface IDropdownBlockProps extends IDropdownProps {
	title: string;
}

const DropdownBlock: React.FC<IDropdownBlockProps> = ({
	title,
	...dropdownProps
}) => {
	return (
		<StyledVerticalContainer>
			<StyledText>{title}</StyledText>
			<Dropdown {...dropdownProps} />
		</StyledVerticalContainer>
	);
};

export { DropdownBlock };
